import styled from '@emotion/styled';

const TagsWrapper = styled('ul')({
  marginTop: 0,
  marginBottom: -8,
  paddingLeft: 0,
  listStyle: 'none',
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
});

export default TagsWrapper;
